import { BaseHttpExtensionService } from '@core/http/base-http-extension.service';
import { MultilingualFormDataManagementService } from '@core/services/multilingual-form-data-management.service';
import { EntityName } from '@shared/enums/entity-name.enum';

export interface LanguageInterface {
  locale: string;
  code: string;
  name: string;
}

export interface TranslationResourceItem {
  key: string;
  value: string;
}

export interface TranslationResourcesCache {
  version: string;
  locale: string;
  data: object;
}

export enum TranslateServiceLanguage {
  en = 'en_US',
  de = 'de_CH',
  fr = 'fr_CH',
}

export interface RemovedLanguage {
  locale?: string;
  existedLocale?: boolean;
}

export interface LanguageSwitcherConfig {
  entityId?: number;
  entityIds?: number[];
  entityName: EntityName | string;
  baseHttpService: BaseHttpExtensionService;
  formDataService: MultilingualFormDataManagementService;
  formIndex: string | number;
  propertyNames: string[];
  creationLocale?: string;
  includeEmptyValue?: boolean;
}
